import { NotificationVariantModel } from '../../../models/notification/notification-variant.model';
import { NotificationActionModel } from '../../../models/notification/notification-action.model';

/**
 * Parse the returned org notification
 * response into a standard notification
 * response for use in building a
 * NotificationVariantModel.
 */
export const parseNotificationVariantFromApiResponse = (data: any) => {
    const template = data.template?.channels?.web ?? {};
    const keywords = data.template?.keywords ?? [];
    const deliverySpec = data.deliverySpec ?? {};

    return NotificationVariantModel.build({
        audience: {
            domainIds: data.notifications?.map(n => n.domainId) ?? [],
        },
        content: {
            default: {
                landingUrl: template.landingUrl,
                title: template.title,
                body: template.body,
                keywords,

                imageUrl: template.imageUrl,
                iconUrl: template.iconUrl,
                isUsingDomainDefaultIcon: template.isUsingDomainDefaultIcon,
                badgeUrl: template.badgeUrl,
                isUsingDomainDefaultBadge: template.isUsingDomainDefaultBadge,

                actions: template.actions?.map(NotificationActionModel.build),
                _custom_actions_enabled: template.overrideDefaultActions,

                experience_options: {
                    isSilent: template.isSilent,
                    requireInteraction: template.requireInteraction,
                    ttlSeconds: deliverySpec.ttl_seconds ?? deliverySpec.ttlSeconds,
                    ttlMetric: deliverySpec.ttl_metric ?? deliverySpec.ttlMetric,
                },
            }
        },
        delivery: {
            type: deliverySpec.type,
            window: deliverySpec.window,
            sendDateUtc: deliverySpec.send_date_utc ?? deliverySpec.sendDateUtc,
            timezone: deliverySpec.timezone,
        },
    });
}
